import {
  StyledLabel,
  StyledSectionTitle,
  StyledTypeSelection
} from './FilterSetForm.style';
import { SAVED_FILTER_SET_TYPES } from '@linearb/linjs-common';
import { FILTER_SET_MODEL } from '../FilterSet.model';
import ErrorMessage from './ErrorMessage';
import { LBLabel, LBRadioGroup, LBRadioGroupItem } from '@linearb/buzz';

const typesOptions = [
  {
    value: SAVED_FILTER_SET_TYPES.FILTER_SET,
    label: <StyledLabel> Filter Set</StyledLabel>
  },
  {
    value: SAVED_FILTER_SET_TYPES.PROJECT,
    label: (
      <StyledLabel> Project (select if there is a target date)</StyledLabel>
    )
  }
];

const TypeSelector = ({ value, onChange, validator }) => {
  return (
    <StyledTypeSelection>
      <StyledSectionTitle>Type</StyledSectionTitle>
      <LBRadioGroup name='type' onValueChange={onChange} value={value}>
        {typesOptions.map(option => (
          <div key={option.value} className='flex flex-row items-center gap-2'>
            <LBRadioGroupItem
              id={option.value}
              value={option.value}
              data-cy={`saved-filter-type-${option.value}`}
            />
            <LBLabel htmlFor={option.value}>{option.label}</LBLabel>
          </div>
        ))}
      </LBRadioGroup>
      <ErrorMessage
        validationError={validator.validationError}
        type={FILTER_SET_MODEL.TYPE}
      />
    </StyledTypeSelection>
  );
};

export default TypeSelector;
